import ahoy from "ahoy.js";

function read_cookie(key)
{
    var result;
    return (result = new RegExp('(?:^|; )' + encodeURIComponent(key) + '=([^;]*)').exec(document.cookie)) ? (result[1]) : null;
}
window.vw = function(v) {
  var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  return (v * w) / 100;
}

$(document).on('turbolinks:load', function () {
    $(".featured-asset-btn").on('click', function () {
      $(".resource-popup-content").empty();
      var stylearea = $(this).data("area");
      $('.popup-header').removeClass("psych").removeClass("neuro").removeClass("respi");
      $('.popup-header').addClass(stylearea)
      var asset = JSON.parse(decodeURIComponent($(this).data('asset')));
      var file = $(this).data('file');
      var vidurls = $(this).data('videourls')
      var resourcepage = $(this).data('resourcepage')
      console.log(vidurls)
      $(".header-text").html(asset.title)
      ahoy.track("asset_view", { title: asset.title, type: asset.resource_type, category: resourcepage + " Resources"});

      console.log(asset);
      switch (asset.resource_type) {
          case 'pdf':
              $(".pdf-pop").show();
              $(".pdf-pop .popup-content").html('<iframe src="/pdfviewer?file='+ encodeURIComponent(file) +'#page=' +  $(this).attr('file') + '" width="100%" height="600px" />')
              break;
          case 'video':
              $(".video-pop").show();
              $(".video-popup .video-content").html('<video controls src="' + vidurls[0].video + '" width="80%" height="auto"></video> \
              <div class="video-button-container">\
              </div > ')


          if (vidurls.length > 1) {
            for (i = 0; i < vidurls.length; i++) {

              $(".video-button-container").append('<button class=" btn video-buttons '+stylearea+'" data-video=' + vidurls[i].video + '>' + vidurls[i].title + '</button>')

            }
          }
              var diseasestate = read_cookie("tparea");
              console.log(diseasestate)
                  if (diseasestate) {
                      $('.video-buttons').removeClass('psych');
                      $('.video-buttons').removeClass('respi');
                      $('.video-buttons').removeClass('neuro');
                }
                  if (diseasestate == "psychiatry") {
                      $('.themed').addClass('psych')

                  } else if (diseasestate == "respiratory") {
                          $('.themed').addClass('respi')

                  } else {
                      $('.themed').addClass('neuro')

                  }

          break;
          case 'link-list':
              $(".resource-pop .popup-content").empty();
              $(".resource-pop").show();

              for (var i = 0; i < asset.link_resources.length; i++){

                  console.log(asset.link_resources)
                  $(".resource-pop .popup-content").append(
                      '<div class="popup-item"> \
                      <div class="">\
                        <div class="popup-reg-title">'+asset.link_resources[i].title+'</div>\
                        <div class="popup-reg-info">'+ (asset.link_resources[i].tagline || "") + '<span>' + (asset.link_resources[i].link || "") +'</span></div> \
                        <a style="text-decoration: none; font-weight: bold" class="leaving-link" infolink='+asset.link_resources[i].link_ref+ ' description='+ asset.description +'>'+asset.link_resources[i].link_ref+ '</a>\
                      </div> \
                      <div  ' +
                      (asset.link_resources[i].link_type == "pdf" ? ' class="pdf-link" pdf= '+ (asset.link_resources[i].link_ref) : 'class="leaving-link" infolink='+asset.link_resources[i].link_ref+ ' description="Sunovion makes no representation as to the accuracy or any other aspect of the information contained in or on the non-Sunovion sites, sources or servers, nor does Sunovion necessarily endorse such sites or sources."') +'>\
                      <div class="resources-button resources-gradient">\
                        View'+ $(this).data('arrow') +
                      '</div> </div>\
                    </div>'
                  )
              }

              break;
              case 'dropdown-list':
                  $(".resource-pop .popup-content").empty();
                  $(".resource-pop").show();
              for (var i = 0; i < asset.dropdowns.length; i++) {

                  $(".resource-pop .popup-content").append(
                      '<div class="popup-item dropdown-item" dropdown-id='+asset.dropdowns[i].id+'> \
                              <div class="">\
                                  <div class="popup-reg-title" style=" color: black;"><strong>'+ asset.dropdowns[i].title + '</strong></div>\
                              </div> \
                              <img src="assets/conference-arrow.svg" class="dropdown-arrow" style="float: right; filter: invert(0%) saturate(0%) hue-rotate(240deg) brightness(0%) contrast(0%);" />\
                          </div>\
                          <div class="dropdown-list-'+asset.dropdowns[i].id+'" style="display: none;"> \
                          </div>'

                  )
                  var links = asset.dropdowns[i].link_resources
                  for (var k = 0; k < links.length; k++) {
                      $('.dropdown-list-'+asset.dropdowns[i].id).append(
                          '<div class="popup-item"> \
                          <div class="">\
                            <div class="dropdown-popup-reg-title popup-reg-title">'+links[k].title+'</div>\
                            <div class="dropdown-popup-reg-info popup-reg-info">'+ (links[k].tagline || "") + '<span>' + (links[k].link || "") +'</span></div> \
                            <a style="text-decoration: none; font-weight: bold" class="dropdown-leaving-link leaving-link" infolink='+links[k].link_ref+ ' description='+ asset.description +'>'+links[k].link_ref+ '</a>\
                          </div> \
                          <div  ' +
                          (links[k].link_type == "pdf" ? ' class="pdf-link" pdf= '+ (links[k].link_ref) : 'class="leaving-link" infolink='+links[k].link_ref+ ' description="Sunovion makes no representation as to the accuracy or any other aspect of the information contained in or on the non-Sunovion sites, sources or servers, nor does Sunovion necessarily endorse such sites or sources."') +'>\
                          <div class="resources-button resources-gradient">\
                            View'+ $(this).data('arrow') +
                          '</div> </div>\
                        </div>'
                      )
                  }

              }
                  break;
          case 'tooltip-list':
              $(".resource-pop .popup-content").empty();
              $(".resource-pop").show();

              for (var i = 0; i < asset.link_resources.length; i++){
                  console.log(asset.link_resources)

                  $(".resource-pop .popup-content").append(
                      '<div class="popup-item"><div class="popup-item-name">'+asset.link_resources[i].title +'<div class="role-info"> \
                      '+ (asset.link_resources[i].tagline != "" ? '<i class="fas fa-info-circle"></i>': '') + ' \
                          <span class="tooltiptext">'+asset.link_resources[i].tagline+'</span></div></div>\
                          <div  ' +
                          (asset.link_resources[i].link_type == "download" ? ' class="pdf-link" pdf= '+ (asset.link_resources[i].link_ref) : 'class="leaving-link" infolink='+asset.link_resources[i].link_ref + ' description="You are now leaving SunovionMedical.com"') +'>\
                        <div class="resources-button resources-gradient">\
                          View'+ $(this).data('arrow') +
                        '</div> </div>\
                    </div>'
                  )
              }
              break;
          case 'link':
              $('.link-popup-container').show()
              var infolink = (asset.link);
              var bottom = (asset.description);

              // $('.link-popup-container').show()


              $('.popup-link').attr('href', infolink)
              break;
          case 'sunovion-link':
                  // $('.link-popup-container').show()
                  var infolink = (asset.link);
                  var bottom = (asset.description);

                  // $('.link-popup-container').show()
                  window.open(infolink, '_blank');


                  $('.popup-link').attr('href', infolink)
                  break;
          case 'file':
              $(".resource-pop").show();

              $(".resource-pop .popup-content").html(
                  '<div class="bottom-text">'+asset.description+'</div> \
                  <a href="'+ file +'" download><div class="reg-button gray-gradient" style="margin-bottom: 5px;">ok</div></a>'
              )
              break;
          case 'internal-link':
            window.location.href = asset.link;
              break;

          case 'grants':
              $(".grant-pop").show();
          break;
      }
  });
  $(".modal-close").on('click', function () {
      $(".resource-pop").hide();
      $('.video-content video')[0].pause()

  })

    var carouselposition = 0;
    //fix height because sizing sucks
    window.fixHeight = function() {
      var maxHeight = -1;
      $('.featured-bar-content').each(function() {
          if ($(this).outerHeight() > maxHeight) {
              maxHeight = $(this).outerHeight();
          }
      });
      $('#carouselscene').height(maxHeight);
    }
    window.fixHeight();
    window.fixAll = function() {
      window.fixHeight();
      window.setupCarousel();
    };

    window.onresize = function() {
     window.fixAll();
    };
    $(window).on("load", function(){
      window.fixAll();
    })

    window.index=0;

  window.setupCarousel = function () {
    var slidenum = $('.slide-container').length
    console.log(slidenum)
      window.transformz = Math.round( ( window.vw(100) / 2 ) /  Math.tan( Math.PI / slidenum ) );
      window.degincr = 360 / slidenum.toFixed(1);
      $("#carouselcontainer").css("transform", "translateZ(-"+window.transformz+"px) rotateY("+(-window.index*window.degincr)+"deg)")
      $(".featured-bar-content").each(function(index, value){
        $(this).css("transform", "rotateY("+(degincr*index)+"deg) translateZ("+window.transformz+"px)");
        console.log(index + value);
      })
    }
    window.setupCarousel();



    if (read_cookie("tparea")) {
      console.log("EYYf")
        swap_diseasestates(read_cookie("tparea"));
    }
    var slides = [];
    var slideindex = 0;

    function setSlide(number) {
      slideindex = number;
      $("#slide-img img").attr("src", slides[number]);
      $("#slide-status").html("SLIDE "+ (number + 1) + " OF " + slides.length);

    }
  $(".program-info").on('click', function () {

      clearInterval(timeout);
      console.log("TEST")
        $("#slide-img img").attr("src", '');

        area = $(this).data("area");
        stylearea = $(this).data("stylearea");

        $('#programpop .popup-header').removeClass("psych").removeClass("neuro").removeClass("respi").addClass(stylearea);
        slides = $(this).data("slides");
        setSlide(0);
        //TODO add imgs to container for slides
        $('#programpop #popup-title').html($(this).data("title"));
        $('#programpop').show();
    });


    var timeoutfunc = function() {
      return setInterval(function() {
       console.log("TIMEOUT")
       $(".rightcara")[0].click();
     }, 20000);
    }
    var timeout = timeoutfunc();
    $("#next-button").on('click', function () {
      setSlide((slideindex + 1 ) % slides.length);
    });
    $("#prev-button").on('click', function () {
      setSlide((((slideindex - 1)%slides.length)+slides.length)%slides.length);
    });
    $(".close-popup").on('click', function () {
      timeout = timeoutfunc();
      $('.popup-container').hide();
    });
    var areamap = [];
    areamap["psych"] = "psychiatry";
    areamap["respi"] = "respiratory";
    areamap["neuro"] = "neurology";
    $(".requestbtn").on('click', function() {
      console.log("BUTTON");
      document.cookie = "selected_program" + "=" + $(this).data('id');
      document.cookie = "tparea=" + areamap[$(this).data('area')] + ";";
      window.location = "./map";
    });
    $(".rightcara").on('click', function () {

        window.index += 1
        $("#carouselcontainer").css("transform", "translateZ(-"+window.transformz+"px) rotateY("+(-window.index*window.degincr)+"deg)")


    });
    $(".leftcara").on('click', function () {
        window.index-= 1;
        $("#carouselcontainer").css("transform", "translateZ(-"+window.transformz+"px) rotateY("+(-window.index*window.degincr)+"deg)")

    });


    function swap_diseasestates(diseasestate) {
        console.log("sdjkajsdaksajks")
        if (diseasestate == "psychiatry") {
            $('.themed').addClass('psych')

        } else if (diseasestate == "respiratory") {
            $('.themed').addClass('respi')

        } else {
            $('.themed').addClass('neuro')
        }
    }
})
